import { ExternalLink, Tag, Trophy } from "lucide-react";

export function calendarLinks(item) {
  if (!item) return [];
  if (item.results_links?.length) return item.results_links;
  return item.results_url ? [{ label: "Resultados", url: item.results_url }] : [];
}

export function CalendarLinks({ item, prefix, size = "sm", className = "" }) {
  const links = calendarLinks(item);
  if (!links.length) return null;
  const pad = size === "lg" ? "px-4 py-2 tracking-[0.22em]" : "px-3 py-2 tracking-[0.2em]";
  return (
    <>
      {links.map((link, index) => {
        const testId = `${prefix}${index ? `-${index}` : ""}`;
        const Icon = link.label.startsWith("Resultados") ? Trophy : Tag;
        if (!link.url) {
          return <span key={`${link.label}-${index}`} className={`inline-flex items-center gap-2 border border-white/15 bg-white/[0.04] font-mono text-[10px] uppercase text-slate-300 ${pad} ${className}`} data-testid={testId}><Icon className="h-3 w-3" /> {link.label}</span>;
        }
        return (
          <a key={`${link.url}-${index}`} href={link.url} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 border border-brass/40 bg-brass/10 font-mono text-[10px] uppercase text-brass transition-colors hover:bg-brass hover:text-charcoal ${pad} ${className}`} data-testid={testId}>
            <Icon className="h-3 w-3" /> {link.label} <ExternalLink className="h-3 w-3" />
          </a>
        );
      })}
    </>
  );
}

export function normalizeKey(value = "") {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}

export function matchCalendarItem(shoot, calendar = []) {
  if (!shoot) return null;
  const sameDay = calendar.filter((item) => item.date <= shoot.date && (item.end_date || item.date) >= shoot.date);
  const title = normalizeKey(shoot.title);
  const location = normalizeKey(shoot.location);
  return sameDay.find((item) => normalizeKey(item.title) === title) || sameDay.find((item) => location && (normalizeKey(item.location).includes(location) || normalizeKey(item.club || "").includes(location))) || null;
}
